<template>
  <v-form ref="form" v-model="formValid">
    <v-container>
      <v-row dense>
        <!-- Selection de membre -->
        <v-col cols="12">
          <service-membre-autocomplete
            v-model="membreId"
            :serviceId="parseInt(this.$route.params.serviceId, 10)"
            :disabled="disabled"
            titulaires
            vacataires
          />
        </v-col>
        <v-col cols="12">
          <s-date-picker
            v-model="creneau.date"
            label="Date"
            required
            :disabled="!editableDate || disabled"
            hide-details
          />
        </v-col>
        <v-col v-if="finLeLendemain" cols="12">
          <s-date-picker :value="dateDeFin" label="Date de fin" required disabled hide-details />
        </v-col>
        <!-- Timepicker Heure de début -->
        <v-col cols="12" sm="6">
          <s-borne-horaire-picker
            v-model="creneau.heureDebut"
            label="Début"
            :borneMax="finLeLendemain ? undefined : creneau.heureFin"
            :disabled="disabled"
            required
          />
        </v-col>
        <!-- Timepicker Heure de fin -->
        <v-col cols="12" sm="6">
          <s-borne-horaire-picker
            v-model="creneau.heureFin"
            label="Fin"
            :borneMin="finLeLendemain ? undefined : creneau.heureDebut"
            :disabled="disabled"
            required
          />
        </v-col>
      </v-row>
    </v-container>
    <small v-if="!disabled">*information obligatoire</small>
    <v-card-actions v-if="!disabled">
      <v-spacer />
      <v-btn color="grey darken-1" text @click="close()"> Annuler </v-btn>
      <v-btn color="success" :disabled="!formValid" @click="validateForm()"> Confirmer </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import ServiceMembreAutocomplete from '../service/service-membre-autocomplete'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'creneau-form',
  components: {
    ServiceMembreAutocomplete,
  },
  props: {
    value: {
      type: Object,
      required: false,
    },
    finLeLendemain: {
      type: Boolean,
      required: false,
      default: false,
    },
    membres: {
      type: Array,
      required: true,
    },
    editableDate: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      formValid: false,
      creneau: undefined,
    }
  },
  computed: {
    ...mapGetters({
      getMembreById: 'membre/getMembreById',
    }),
    membreId: {
      get() {
        if (this.creneau.membre) {
          return this.creneau.membre.membreId
        } else {
          return this.creneau.membreId
        }
      },
      set(_membreId) {
        this.creneau.membreId = _membreId
      },
    },
    dateDeFin() {
      const debut = this.creneau.heureDebut.heure * 60 + this.creneau.heureDebut.minute
      const fin = this.creneau.heureFin.heure * 60 + this.creneau.heureFin.minute
      const date = moment(this.creneau.date)
      if (fin < debut) {
        return date.add(1, 'day').format('YYYY-MM-DD')
      } else {
        return date.format('YYYY-MM-DD')
      }
    },
  },

  created() {
    this.creneau = JSON.parse(JSON.stringify(this.value))
  },
  watch: {
    creneau() {
      this.$emit('input', this.creneau)
    },
    menu() {
      if (this.menu === false) {
        this.$refs.form.reset()
      }
    },
  },
  methods: {
    validateForm() {
      this.$refs.form.validate()
      if (this.formValid) {
        this.$emit('validated', { ...this.creneau, dateDeFin: this.dateDeFin })
      }
    },
    close() {
      this.$emit('close')
      this.menu = false
    },
  },
}
</script>

<style scoped></style>
